<div class="status-wrapper p-2" *ngIf="status != null">
    <div [matTooltip]="errorMessage" matTooltipPosition="right" class="status-bar p-2 d-flex align-items-center justify-content-center" [ngClass]="status == subscriptionError.Valid ? 'bg-default' : 'bg-warning'">
        <i class="fa" [ngClass]="status == subscriptionError.Valid ? 'fa-check-circle-o' : 'fa-exclamation-circle'"></i>
        <span *ngIf="sidenavExpanded" class="error-code ps-2 dosis">{{errorCode}}</span>
    </div>
</div>